@defer {
<app-festival-decoration></app-festival-decoration>
<div class="login_page" [class.fall-of-summer]="fallOfSummer" [class.thanksgiving]="thanksgiving" [class.halloween]="halloween" [class.remembrance]="remembrance" [class.festival-active]="hideLoginIllustrations">
  @if (!hideLoginIllustrations) {
  <div class="illustration left" [class]="'entry-' + entryPoint">
    <img src="assets/images/login/all-sd.png" alt="Shade Illustration" />
    <img src="assets/images/login/cycl.png" alt="Bike Illustration" />
    <img src="assets/images/login/road.png" alt="Road Illustration" />
  </div>
  }

  <div class="login_card" [class.login_card--password-step]="showPasswordField()">
    <img src="assets/images/login/techwyse-logo.png" class="logo" alt="TechWyse Logo" />
    @if (remembrance) {
    <img src="assets/images/events/rem-poppy.png" class="remembrance-poppy" alt="" draggable="false" />
    }

    <div class="quote quote--stacked">
      <img src="assets/images/forgot.gif" class="forgot-gif" alt="Forgot password" />
      <div class="quote-copy">
        <h1 class="quote-title">{{ stepTitle() }}</h1>
        <p class="quote-message">{{ stepMessage() }}</p>
        @if (showPasswordField()) {
        <p class="quote-helper">Enter and confirm your New Password below.</p>
        }
      </div>
    </div>

    <!-- Email Form -->
    @if (!showOtpField() && !showPasswordField()) {
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendOtp()">
      <div class="input_group">
        <div class="form-fields"
          [class]="email?.valid && email?.touched && !errorMessage() ? 'input-with-success' : showEmailFieldError() ? 'input-with-error' : ''">
          <input type="text" id="email" formControlName="email" placeholder="Email or Phone" autocapitalize="off"
            autocomplete="off" autocorrect="off" spellcheck="false"
            [class.is-invalid]="showEmailFieldError()"
            [class.is-valid]="email?.valid && email?.touched"
            (input)="onEmailInput($event)" (focus)="onEmailFocus()" (blur)="onEmailBlur()" />
          @if (email?.valid && email?.touched && !errorMessage()) {
          <span class="success-circle"></span>
          }
          @if (showEmailFieldError()) {
          <span class="error-circle"></span>
          }
        </div>
      </div>
      <div class="error_wrap">@if (showEmailFieldError() && getErrorMessage('email', forgotPasswordForm)) {
        <div class="error_message">
          {{ getErrorMessage('email', forgotPasswordForm) }}
        </div>
        }
      </div>

      <div class="btn_wrap">
        <a routerLink="#/login" class="back-link">Back to Login</a>
        <app-auth-festive-decoration page="forgot"></app-auth-festive-decoration>
        <button type="submit" [disabled]="forgotPasswordForm.invalid || isLoading()">
          @if (!isLoading()) {
          <span>Send OTP</span>
          } @else {
          <app-spinner [size]="16"></app-spinner>
          }
        </button>
      </div>
    </form>
    }

    <!-- OTP Form -->
    @if (showOtpField() && !showPasswordField()) {
    <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
      <p class="step-helper-text">Type the 4-digit code from your message.</p>
      <div class="input_group">
        <div class="form-fields">
          <div class="otp-input-container">
            @for (i of [0,1,2,3]; track i) {
            <input type="text" [formControlName]="'otp' + (i + 1)" class="otp-input"
              [class.is-invalid]="otpForm.get('otp' + (i + 1))?.errors?.['backendError']" maxlength="1"
              (input)="onOtpInput($event, i)" (keydown)="onKeyDown($event, i + 1)" (paste)="onOtpPaste($event)" />
            }
          </div>
          @if (otpForm.invalid && otpForm.touched &&!errorMessage()) {
          <div class="validation_error">
            Please enter all 4 digits
          </div>
          }
        </div>
      </div>
      <div class="error_wrap">@if (errorMessage() && otpForm.get('otp1')?.errors?.['backendError'] ) {
        <div class="error_message">
          {{ errorMessage() }}
        </div>
        }
      </div>
      <div class="btn_wrap">
        <a routerLink="#/login" class="back-link">Back to Login</a>
        <button type="submit" [disabled]="otpForm.invalid || isLoading()">
          @if (!isLoading()) {
          <span>Verify OTP</span>
          } @else {
          <app-spinner [size]="16"></app-spinner>
          }
        </button>
      </div>
    </form>
    }

    <!-- New Password Form -->
    @if (showPasswordField()) {
    <form class="new-password-form" [formGroup]="newPasswordForm" (ngSubmit)="resetPassword()">
      <div class="input_group">
        @if ((newPasswordForm.get('password')?.touched && newPasswordForm.get('password')?.errors) && !errorMessage()) {
        <div class="validation_error nw_pss_err">
          {{ getErrorMessage('password', newPasswordForm) }}
        </div>
        }
        <div class="form-fields"
          [class]="newPasswordForm.get('password')?.valid && newPasswordForm.get('password')?.touched ? 'input-with-success' : (newPasswordForm.get('password')?.invalid && (isPasswordTyping() || newPasswordForm.get('password')?.touched)) || newPasswordForm.get('password')?.errors?.['backendError'] ? 'input-with-error' : ''">
          <div class="password-input-container">
            <input [type]="showPassword() ? 'text' : 'password'" id="password" formControlName="password"
              placeholder="Enter New Password"
              [class.is-invalid]="(newPasswordForm.get('password')?.invalid && (isPasswordTyping() || newPasswordForm.get('password')?.touched)) || newPasswordForm.get('password')?.errors?.['backendError']"
              [class.is-valid]="newPasswordForm.get('password')?.valid && newPasswordForm.get('password')?.touched"
              (input)="onPasswordInput()" (focus)="onPasswordFocus()" />
            <span class="toggle" (click)="togglePasswordVisibility()">
              {{ showPassword() ? 'Hide' : 'Show' }}
            </span>
          </div>
          @if (newPasswordForm.get('password')?.valid && newPasswordForm.get('password')?.touched) {
          <span class="success-circle"></span>
          }
          @if ((newPasswordForm.get('password')?.invalid && (isPasswordTyping() ||
          newPasswordForm.get('password')?.touched)) || newPasswordForm.get('password')?.errors?.['backendError']) {
          <span class="error-circle"></span>
          }
        </div>
      </div>

      <div class="input_group">
        @if ((((newPasswordForm.get('confirmPassword')?.touched && newPasswordForm.get('confirmPassword')?.errors) ||
          (newPasswordForm.errors?.['passwordMismatch'] && newPasswordForm.get('confirmPassword')?.touched))) && !errorMessage()) {
        <div class="validation_error">
          {{ getErrorMessage('confirmPassword', newPasswordForm) }}
        </div>
        }
        <div class="form-fields"
          [class]="newPasswordForm.get('confirmPassword')?.valid && newPasswordForm.get('confirmPassword')?.touched && !newPasswordForm.errors?.['passwordMismatch'] ? 'input-with-success' : ((newPasswordForm.get('confirmPassword')?.invalid && (isConfirmPasswordTyping() || newPasswordForm.get('confirmPassword')?.touched)) || (newPasswordForm.errors?.['passwordMismatch'] && newPasswordForm.get('confirmPassword')?.touched)) ? 'input-with-error' : ''">
          <div class="password-input-container">
            <input [type]="showConfirmPassword() ? 'text' : 'password'" id="confirmPassword"
              formControlName="confirmPassword" placeholder="Confirm New Password"
              [class.is-invalid]="((newPasswordForm.get('confirmPassword')?.invalid && (isConfirmPasswordTyping() || newPasswordForm.get('confirmPassword')?.touched)) || (newPasswordForm.errors?.['passwordMismatch'] && newPasswordForm.get('confirmPassword')?.touched))"
              [class.is-valid]="newPasswordForm.get('confirmPassword')?.valid && newPasswordForm.get('confirmPassword')?.touched && !newPasswordForm.errors?.['passwordMismatch']"
              (input)="onConfirmPasswordInput()" (focus)="onConfirmPasswordFocus()" />
            <span class="toggle" (click)="toggleConfirmPasswordVisibility()">
              {{ showConfirmPassword() ? 'Hide' : 'Show' }}
            </span>
          </div>
          @if (newPasswordForm.get('confirmPassword')?.valid && newPasswordForm.get('confirmPassword')?.touched &&
          !newPasswordForm.errors?.['passwordMismatch']) {
          <span class="success-circle"></span>
          }
          @if (((newPasswordForm.get('confirmPassword')?.invalid && (isConfirmPasswordTyping() ||
          newPasswordForm.get('confirmPassword')?.touched)) || (newPasswordForm.errors?.['passwordMismatch'] &&
          newPasswordForm.get('confirmPassword')?.touched))) {
          <span class="error-circle"></span>
          }
        </div>
      </div>
      <div class="error_wrap">
        @if (errorMessage()) {
        <div class="error_message">
          {{ errorMessage() }}
        </div>
        }
      </div>
      <div class="btn_wrap">
        <a routerLink="#/login" class="back-link">Back to Login</a>
        <button type="submit" [disabled]="newPasswordForm.invalid || isLoading()">
          @if (!isLoading()) {
          <span>Reset Password</span>
          } @else {
          <app-spinner [size]="16"></app-spinner>
          }
        </button>
      </div>
    </form>
    }

    <img src="assets/images/login/workluge-logo.png" class="footer_logo" alt="WorkLuge Logo" />
  </div>

  @if (remembrance) {
  <div class="remembrance-bees" aria-hidden="true">
    @for (bee of loginHoneybees; track $index) {
    <img
      class="remembrance-bee"
      [class.remembrance-bee--right]="bee.path === 'right'"
      [class.remembrance-bee--left]="bee.path === 'left'"
      src="assets/images/events/honeybee.gif"
      alt=""
      draggable="false"
      loading="lazy"
      decoding="async"
      [style.--bee-left]="bee.left"
      [style.--bee-top]="bee.top"
      [style.--bee-size]="bee.size"
      [style.--bee-duration]="bee.duration"
      [style.--bee-delay]="bee.delay"
    />
    }
  </div>
  }

  @if (!hideLoginIllustrations) {
  <div class="illustration right">
    <img src="assets/images/login/str-grp.png" alt="Star Illustration" />
    <img src="assets/images/login/moon.png" alt="Moon Illustration" />
  </div>
  }
</div>
<footer
  [class.fall-of-summer]="fallOfSummer"
  [class.thanksgiving]="thanksgiving"
  [class.halloween]="halloween"
  [class.remembrance]="remembrance"
>© 2000–{{ currentYear }} Licenced Copyright by TechWyse. All rights reserved.</footer>
}